import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

/**
 * Rounded on all four corners, not just the top two.
 *
 * The grey action strip at the foot rounds its own bottom corners, and this panel behind it did not -
 * so a couple of white pixels showed through in each bottom corner, as if the strip were sitting on a
 * square card. `overflow: hidden` means the panel now clips the strip, and the two agree by
 * construction rather than by both being told 8px.
 */
export const wrapperSx: SxProps<Theme> = {
    background: theme.palette.common.white,
    borderRadius: '14px',
    border: '1px solid rgba(0, 0, 0, 0.05)',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05), 0 4px 12px rgba(0,0,0,0.04)',
    overflow: 'hidden',
};

export const titleSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    px: 2.5,
    py: 1.75,
};

export const scheduleBadgeSx: SxProps<Theme> = {
    width: '32px',
    height: '32px',
    borderRadius: '8px',
    background: `linear-gradient(135deg, ${theme.palette.primaryColor[50]} 0%, ${theme.palette.primaryColor[100]} 100%)`,
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& svg': {fontSize: '18px'},
};

export const scheduleTitleTextSx: SxProps<Theme> = {
    fontSize: '1rem',
    fontWeight: 600,
    color: theme.palette.primary.main,
};

export const buttonSx: SxProps<Theme> = {
    borderWidth: theme.spacing(2 / 8),
    borderStyle: 'solid',
    borderColor: theme.palette.primary.main,
    background: theme.palette.primary.main,
    color: theme.palette.text.secondary,
    '&:hover': {
        color: theme.palette.primary.main,
    },
};

export const emptyWrapperSx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(20 / 8),
    padding: theme.spacing(5 / 8, 10 / 8, 25 / 8),
};

export const emptyTitleWrapperSx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(10 / 8),
};

export const actionButtonWrapperSx: SxProps<Theme> = {
    width: '100%',
    background: theme.palette.neutral[100],
    // No radius of its own: the panel clips it. Two radii kept in step by hand is how they drifted.
    borderRadius: 0,
    '& button': {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        gap: theme.spacing(5 / 8),
        color: theme.palette.text.primary,
    },
};
